import FormFieldViewText from "components/FormFields/ViewText";
import FormField from "ds/components/Form/Field";
import SecretFieldDetails from "ds/components/SecretFieldDetails";
import useTypedFlags from "hooks/useTypedFlags";
import { BitbucketCloudIntegration } from "types/generated";

import { REGENERATE_BITBUCKET_CLOUD_INTEGRATION_WEBHOOK_SECRET } from "../../gql";
import { useRefreshSecret } from "../../useRefreshSecret";
import { VCSCheckLabels } from "./helpers";
import VCSIntegrationsUseGitCheckoutInfo from "./UseGitCheckoutInfo";

type VCSIntegrationsDetailsBitbucketCloudProps = {
  details: BitbucketCloudIntegration;
  canEdit?: boolean;
};

const VCSIntegrationsDetailsBitbucketCloud = ({
  details,
  canEdit,
}: VCSIntegrationsDetailsBitbucketCloudProps) => {
  const { bitbucketApiTokenSupport } = useTypedFlags();
  const [webhookSecret, regenerateSecret] = useRefreshSecret(
    details.id,
    details.webhookSecret,
    REGENERATE_BITBUCKET_CLOUD_INTEGRATION_WEBHOOK_SECRET,
    (data) => data.bitbucketCloudIntegrationRegenerateWebhookSecret.webhookSecret
  );

  return (
    <>
      {bitbucketApiTokenSupport ? (
        <FormFieldViewText label="Email" value={details.email} />
      ) : (
        <FormFieldViewText label="Username" value={details.username} />
      )}

      <FormField label="Webhook secret">
        <SecretFieldDetails
          secret={webhookSecret}
          regenerateSecret={canEdit ? regenerateSecret : undefined}
        />
      </FormField>

      <FormFieldViewText
        label="Webhook endpoint"
        value={details.webhookUrl}
        withCopy
        noTextEllipsis
        textWordBreak
      />

      <VCSIntegrationsUseGitCheckoutInfo value={details.useGitCheckout} />

      <FormFieldViewText label="VCS checks" value={VCSCheckLabels[details.vcsChecks]} />
    </>
  );
};

export default VCSIntegrationsDetailsBitbucketCloud;
